<div id=" menu-bars " class="menu-bars hidden-lg hidden-xlg ">
  <button id="menu-bars-bars" class="btn btn-stacked toggle-nav" type="button" tabindex="0" aria-expanded="false">
    <span class="fa fa-bars" aria-hidden="true"></span>
    <span class="mobile-buttons-text">Menu</span>
  </button>
</div>
